import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'add-new-element-btn',
	template: require('./add-new-element-btn.component.html'),
	styles: [require('./add-new-element-btn.component.scss')]
})
export class AddNewElementBtnComponent {
	@Input() icon: string;
	@Input() imgSrc: string;
	@Input() title: string;
	@Input() description: string;
	@Output() onBtnClicked: EventEmitter<any> = new EventEmitter<any>();

	constructor() {}

	onButtonClicked() {
		this.onBtnClicked.next();
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/buttons/add-new-element-btn/add-new-element-btn.component.ts